import { useEffect, useState } from "react";

import {
    useNavigate,
    useParams,
} from "react-router-dom";

import PageHeader from "../components/PageHeader";
import BannerEditor from "../components/BannerEditor";

import useCategories from "../hooks/useCategories";
import usePosts from "../hooks/usePosts";
import useBanners from "../hooks/useBanners";

export default function EditBannerPage() {

    const { bannerId } = useParams();

    const navigate = useNavigate();


    const { categories } = useCategories();

    const { posts } = usePosts();

    const {
        getBanner,
        updateBanner,
        saving,
    } = useBanners();

    const [loading, setLoading] = useState(true);

    const [formData, setFormData] = useState({

        title: "",

        message: "",

        cta_text: "",

        cta_url: "",

        placement: "inline",

        category: "",

        blog: "",

        image: null,

        is_active: true,

        starts_at: "",

        ends_at: "",

    });

    

    useEffect(() => {

        const loadBanner = async () => {

            try {

                const banner = await getBanner(bannerId);

                setFormData({
                    title: banner.title || "",
                    message: banner.message || "",
                    cta_text: banner.cta_text || "",
                    cta_url: banner.cta_url || "",
                    placement: banner.placement || "inline",
                    category: banner.category || "",
                    blog: banner.blog || "",
                    image: banner.image || null,
                    is_active: banner.is_active,
                    starts_at: banner.starts_at || "",
                    ends_at: banner.ends_at || "",
                });

            } finally {

                setLoading(false);

            }

        };

        loadBanner();

    }, [bannerId]);

    const updateField = (field, value) => {

        setFormData(prev => ({
            ...prev,
            [field]: value,
        }));

    };

    const handleSubmit = async () => {

        await updateBanner(bannerId, formData);

        navigate("/admin/banners");

    };

    if (loading) {

        return (

            <div className="py-24 text-center">

                Loading banner...

            </div>

        );

    }

    return (

        <div className="space-y-8">

            <PageHeader
                title="Edit Banner"
                subtitle="Advertisement Management"
            />

            <BannerEditor
                formData={formData}
                updateField={updateField}
                categories={categories}
                posts={posts}
            />

            <div className="flex justify-end">

                <button
                    onClick={handleSubmit}
                    disabled={saving}
                    className="
                        px-8
                        py-3
                        rounded-xl
                        bg-blue-800
                        text-white
                        font-semibold
                        hover:bg-blue-600
                        disabled:opacity-60
                    "
                >
                    {saving
                        ? "Saving..."
                        : "Save Changes"}
                </button>

            </div>

        </div>

    );

}